import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { LegalentityRollbackCommandForm } from './LegalentityRollbackCommandForm'

export const LegalentityRollbackCommand = (props: ActionButtonProps) => {
  const translate = useTranslate()

  const { legalEntityId, tenantId } = useHook(
    'routing.general.useLegalEntityParams',
  )()
  const actions = useHook('mutators.crm.useRollbackActions')({
    tenantId,
    personId: legalEntityId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="legalEntity.RollbackCommandData"
      title={translate('legalentity.rollbackEventModalButton.title')}
      commandDataForm={LegalentityRollbackCommandForm}
      {...props}
      submit={submit}
    />
  )
}
